var observer = require("../utilities/observer");
import { appendToUrl } from "../search/urlUtils";
import { loadLazyImages } from "../utilities/globalUtilities";
import { handlePDPRecommendationsSetup } from "./detailsUtil";

/**
 * @function
 * @description - PDP recommendations intersection observer action
 * @param {Object} e - recommendations element
 */
function pdpRecommendationIntersection(e) {
    const $pdpRecommendations = $(e.target);

    if ($pdpRecommendations.hasClass("js-slot-recommendations")) { return; }

    let url = $pdpRecommendations.data("url");
    const products = $pdpRecommendations.data("products");
    const urlParams = {
        products: products
    };

    if (!url) { return; }

    url = appendToUrl(url, urlParams);

    $.ajax({
        url: url,
        type: "GET",
        dataType: "html",
        complete: data => {
            $pdpRecommendations.addClass("d-none").html(data.responseText);
            handlePDPRecommendationsSetup();
        }
    });
}

/**
 * @function
 * @description - PDP recommendations mutation observer action
 */
function pdpRecommendationsMutation() {
    const $recommendationsWrapper = $(".ct-pdp--recommendations, .ct-clp--recommendations");

    if ($recommendationsWrapper.children().length > 0) {
        if ($recommendationsWrapper.hasClass("js-slot-recommendations") && !$recommendationsWrapper.find(".slick-initialized").length) {
            handlePDPRecommendationsSetup();
        }

        loadLazyImages(".ct-pdp--recommendations, .ct-clp--recommendations");
        $recommendationsWrapper.removeClass("d-none");
    }
}

/**
 * @function
 * @description - Intersection observer definition for videos section
 */
const intersectionObserver = () => {
    if (!("IntersectionObserver" in window)) {
        require("../thirdParty/intersection-observer");
    }

    var targetRecommendations = document.querySelectorAll(".js-recommendations");

    targetRecommendations.forEach(recommendation => {
        observer.initIntersection(recommendation, pdpRecommendationIntersection);
        observer.initMutation(recommendation, pdpRecommendationsMutation);
    });
};

export { intersectionObserver };
